import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavbarOne = _resolveComponent("NavbarOne")!
  const _component_PageBanner = _resolveComponent("PageBanner")!
  const _component_WhoWeAre = _resolveComponent("WhoWeAre")!
  const _component_PoweringDailyLife = _resolveComponent("PoweringDailyLife")!
  const _component_OurMission = _resolveComponent("OurMission")!
  const _component_OurVision = _resolveComponent("OurVision")!
  const _component_PartnerLogo = _resolveComponent("PartnerLogo")!
  const _component_EnjoySports = _resolveComponent("EnjoySports")!
  const _component_FanFact = _resolveComponent("FanFact")!
  const _component_FAQ = _resolveComponent("FAQ")!
  const _component_OurLatestArticles = _resolveComponent("OurLatestArticles")!
  const _component_SubscribeContent = _resolveComponent("SubscribeContent")!
  const _component_MainFooter = _resolveComponent("MainFooter")!
  const _component_CopyRight = _resolveComponent("CopyRight")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NavbarOne),
    _createVNode(_component_PageBanner, {
      pageTitle: "من نحن",
      subTitle: "خدمة ترفيهية متكاملة لمشاهدة القنوات العربية والعالمية والأفلام والمسلسلات بجودة عالية وثبات ممتاز",
      pageBannerImage: _ctx.pageBannerImg
    }, null, 8, ["pageBannerImage"]),
    _createVNode(_component_WhoWeAre),
    _createVNode(_component_PoweringDailyLife),
    _createVNode(_component_OurMission),
    _createVNode(_component_OurVision),
    _createVNode(_component_PartnerLogo),
    _createVNode(_component_EnjoySports),
    _createVNode(_component_FanFact),
    _createVNode(_component_FAQ),
    _createVNode(_component_OurLatestArticles),
    _createVNode(_component_SubscribeContent),
    _createVNode(_component_MainFooter, { class: "bg-black" }),
    _createVNode(_component_CopyRight)
  ], 64))
}